<template>
  <div class="main">
    <div class="inner">
      <div class="icon icon-bg-0"></div>
      <div class="icon icon-bg-1"></div>
      <div class="qr-wrap">
        <canvas id="qr-canvas"></canvas>
      </div>
      <div class="tip">请使用微信扫码在手机上使用</div>
    </div>
  </div>

</template>

<script>
var QRCode = require("qrcode");
import $ from "jquery";

export default {
  title: "请微信扫码使用",
  bodyClass: "white-bg",
  components: {},
  data() {
    return {};
  },
  mounted() {
    $('meta[name="viewport"]').remove();
    //设置二维码
    if (this.$route.query.url) {
      setTimeout(() => {
        //生成二维码
        var canvas = document.getElementById("qr-canvas");

        QRCode.toCanvas(canvas, this.$route.query.url, { width: 360,errorCorrectionLevel: 'H',margin: 1 }, function(
          error
        ) {
          if (error) {
            console.error(error);
            return;
          }
          console.log("qr success!");
        });
      }, 100);
    }
  }
};
</script>

<style scoped lang="less">
.inner{
  position: relative;
  width: 750px;
  height: 750px;
  margin: 90px auto;
  background: white;
  border-radius: 30px;
  box-shadow:2px 2px 11px #dddddd;
  font-size: 20px;
  overflow: hidden;

  .icon-bg-0{
    background-image: url(../../assets/icon-setting-bg-1.png);
    width: 100%;
    height: 252px;
    background-size: cover;
    background-position: bottom;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
  }

  .icon-bg-1{
    background-image: url(../../assets/icon-setting-bg-0.png);
    width: 192px;
    height: 153px;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    position: absolute;
    top: 45px;
    left: 33px;
    z-index: 1;
  }


  .qr-wrap{
    position: relative;
    display: block;
    margin: 180px auto 60px;
    text-align: center;
    z-index: 2;
  }

  #qr-canvas{
    display: inline-block;
  }

  .tip{
    text-align: center;
    color: #666;
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/public/PC.vue